<template>
  <!-- w 13 h 13  -->
  <path d="M1.06714 6.5L5.0495 10.8659L12.0898 1.13406" stroke="white" stroke-width="1.5" />
</template>
